import { put, takeLatest } from 'redux-saga/effects';
import { ManageModuli } from '../../reducers/r_index';
import { MessageType, Message } from '../../utils/variables';

import authService from './../../components/api-authorization/AuthorizeService';

// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { pk, IDModulo, tipologia } }) {
    try {

        const token = yield authService.getAccessToken();

        const response = yield fetch('/Licenses/GetCodiceModuli/'
            + pk + '/'
            + IDModulo + '/'
            + tipologia, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });


        let moduli = yield response.json();

        if (typeof moduli === "string") {

            if (moduli === Message.CodiceModuliPrimaAttivazione) {
                yield put(ManageModuli.creators.getCodiceModuliSuccess({ moduli, new_moduli: null }));
            }
            else if (moduli.includes(MessageType.Error)) {
                yield put(ManageModuli.creators.getCodiceModuliFailed(moduli));
            }
            else {
                yield put(ManageModuli.creators.getCodiceModuliFailed(moduli));
            }
        }
        else {
            //converto NumUtenti a string dato che nella Textfield viene gestito come se fosse una stringa
            moduli.NumUtenti = moduli.NumUtenti.toString();

            yield put(ManageModuli.creators.getCodiceModuliSuccess({ moduli, new_moduli: moduli }));
        }

    } catch (e) {
        yield put(ManageModuli.creators.getCodiceModuliFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(ManageModuli.types.GET_CODICE_MODULI_REQUEST, runAction);
}

/*

const moduli = {
      NumUtenti: 6,
      LicNonRivend: true,
      MagDoc: {
        DocMag: true,
        Commesse: true,
        Lotti: true,
        Rapportini: true
      },
      DistBase: {
        DistintaBase: true,
        Produzione: true,
        RilTempi: true
      },
      Contabilita: {
        Contab: true,
        Analitica: true,
        Cespiti: true,
        SintesiDati: true,
        ModuloFiscale: true,
        Gold: true
      },
      Generali: {
        DocumentiDigitali: true,
        PostaElettronica: true,
        EasyCRM: true,
        Cruscotto: true,
        ECommerce: true,
        MultiLingua: true,
        RilevPres: true,
        Dashboard: true,
        BeniImmob: true,
        Documenti: true,
        Bartolini: true,
        VisionPivot: true,
        VisionDataView: true,
        VisionProduce: true,
        VisionDocumatic: true,
        FEBase: true,
        VisionCatalogo: true,
        VisionSms: true,
        VisionVortal: true,
        VisionMobile: true,
        VisionAssist: true,
        VisionOffline: true,
        VisionRetail: true,
        FeFull: true
      }
    };

 */